import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import i18n from 'src/i18n'

import { useCurrentUserQuery } from 'src/app/auth/repositories/use-current-user-query'
import { useHanwhaAccessQuery } from 'src/app/auth/repositories/use-hanwha-access-query'
import { useAuthStore } from 'src/app/auth/store/auth-store'
import { Toast, toastTypes } from 'src/app/core/services/toast'

export const useSessionGuard = (): void => {
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore(state => state.isAuthenticated())
  const uuid = useAuthStore(state => state.currentUser?.data.uuid ?? null)
  const isSuperAdmin = useAuthStore(
    state => state.currentUser?.data.isSuperAdmin === true,
  )
  const setCurrentUser = useAuthStore(state => state.setCurrentUser)

  useCurrentUserQuery({ enabled: isAuthenticated })

  const accessQuery = useHanwhaAccessQuery({
    uuid,
    enabled: isAuthenticated && !isSuperAdmin,
  })

  useEffect(() => {
    if (!isAuthenticated) return
    if (isSuperAdmin) return
    if (accessQuery.isSuccess && !accessQuery.data.allowed) {
      Toast.notify({
        title: i18n.t('auth.login.errors.notAuthorizedTitle'),
        message: i18n.t('auth.login.errors.notAuthorized'),
        type: toastTypes.ERROR,
      })
      setCurrentUser(null)
      navigate('/login', { replace: true })
    }
  }, [
    isAuthenticated,
    isSuperAdmin,
    accessQuery.isSuccess,
    accessQuery.data,
    navigate,
    setCurrentUser,
  ])
}
